module.exports = "https://static.wmbcdn.com/uniweb/images/594ed4a631f181a69c94450e7cd21edf.mp4";